import React, { Component } from 'react';
import Divider from '@material-ui/core/Divider';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import EntreeSection from './EntreeCart';
import SideSection from './sideCart';
import { PopupboxContainer } from 'react-popupbox';
import 'react-popupbox/dist/react-popupbox.css';
import { connect } from 'react-redux';

class check extends Component {
  state = {
    entrees: '',
    error: false,
    valueOne: '',
    valueTwo: '',
    deselect: false,
    imageUrl: '',
    handle: '',
    toppings: [{}],
    one: [{}],
    protein: [{}],
    test: [{}],
    showEntrees: true,
    showSides: false,
    showDrinks: false,
  };

  componentDidMount = () => {
    const handle = this.props.match.params.handle;
    const imageUrl = this.props.location.state.imageUrl;

    this.setState({
      handle: handle,
      imageUrl: imageUrl,
    });
  };

  setEntrees = () => {
    if (this.state.showEntrees) {
    } else {
      document.getElementById('id-entrees').style.textDecoration = 'underline';
      document.getElementById('id-entrees').style.fontWeight = 'bold';

      document.getElementById('id-sides').style.fontWeight = 'normal';
      document.getElementById('id-sides').style.textDecoration = 'none';

      document.getElementById('id-drinks').style.fontWeight = 'normal';
      document.getElementById('id-drinks').style.textDecoration = 'none';

      this.setState({
        showEntrees: true,
        showSides: false,
        showDrinks: false,
      });
    }
  };

  setSides = () => {
    if (this.state.showSides) {
    } else {
      document.getElementById('id-sides').style.textDecoration = 'underline';
      document.getElementById('id-sides').style.fontWeight = 'bold';

      document.getElementById('id-entrees').style.textDecoration = 'none';
      document.getElementById('id-entrees').style.fontWeight = 'normal';

      document.getElementById('id-drinks').style.fontWeight = 'normal';
      document.getElementById('id-drinks').style.textDecoration = 'none';

      this.setState({
        showSides: true,
        showEntrees: false,
        showDrinks: false,
      });
    }
  };

  setDrinks = () => {
    if (this.state.showDrinks) {
    } else {
      document.getElementById('id-drinks').style.textDecoration = 'underline';
      document.getElementById('id-drinks').style.fontWeight = 'bold';

      document.getElementById('id-entrees').style.textDecoration = 'none';
      document.getElementById('id-entrees').style.fontWeight = 'normal';

      document.getElementById('id-sides').style.fontWeight = 'normal';
      document.getElementById('id-sides').style.textDecoration = 'none';

      this.setState({
        showDrinks: true,
        showSides: false,
        showEntrees: false,
      });
    }
  };

  render() {
    const handle = this.props.match.params.handle;
    const sides = this.props.location.state.sides;

    const { orderCount } = this.props;

    return (
      <div style={{ maxWidth: '410px', margin: '0 auto', zIndex: 1 }}>
        <Card style={{ display: 'flex' }}>
          <a href="/">
            <img src="/smallup2.png" alt="up2" style={{ height: '8vh' }} />
          </a>

          <CardContent style={{ width: '350px' }}>
            {/* <CardMedia image='/smallup2.png' style={{height:'8vh'}}/> */}
            <Typography
              variant="h5"
              style={{
                textAlign: 'center',
                backgroundColor: 'white',
              }}
            >
              {handle}
            </Typography>
          </CardContent>

          <Avatar
            style={{
              width: '115px',
              height: '9vh',
              backgroundColor: '#00b2ffd1',
              borderRadius: '0',
            }}
          >
            <div>
              <div>
                <div>
                  <img
                    alt="whiteCart"
                    src="/whitecart.svg"
                    style={{
                      minWidth: '25px',
                      maxHeight: '30px',
                    }}
                  />
                </div>
              </div>
              <Link
                style={{ textDecoration: 'none', color: 'white' }}
                to={{
                  pathname: '/checkout/confirm/Chuys',
                }}
              >
                <Typography
                  style={{
                    fontSize: '13px',
                    fontWeight: '700',
                  }}
                >
                  View
                </Typography>
              </Link>
            </div>
            <Typography
              style={{
                marginLeft: '7vw',
                fontSize: '1.7rem',
                fontWeight: '700',
              }}
            >
              {orderCount}
            </Typography>
          </Avatar>
        </Card>

        {/* <img src="/solidcart.png"/> */}
        <div>
          <Typography
            style={{
              textAlign: 'center',
              marginTop: '5px',
            }}
          >
            <Button onClick={this.setEntrees}>
              <div
                id="id-entrees"
                style={{
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  textDecoration: 'underline',
                }}
              >
                Entrees
              </div>
            </Button>
            <Button onClick={this.setSides}>
              <div id="id-sides" style={{ fontSize: '1rem' }}>
                Sides
              </div>
            </Button>
            <Button id="id-drinks" onClick={this.setDrinks}>
              {' '}
              Drinks
            </Button>
          </Typography>
        </div>

        <Divider />

        {this.state.showEntrees === true ? (
          <div>
            <Typography variant="h6" style={{ paddingLeft: '10px' }}>
              {' '}
              Entrees
            </Typography>
            <EntreeSection
              entrees={this.props.location.state.entrees}
              user={this.props}
              handle={this.props.match.params.handle}
            />{' '}
          </div>
        ) : (
          <div></div>
        )}

        {this.state.showSides === true ? (
          <div>
            <Typography variant="h6" style={{ paddingLeft: '10px' }}>
              {' '}
              Sides
            </Typography>
            <SideSection sides={sides} user={this.props} handle={handle} />
          </div>
        ) : (
          <div></div>
        )}

        {this.state.showDrinks === true ? (
          <div>
            <Typography variant="h6" style={{ paddingLeft: '10px' }}>
              {' '}
              Drinks
            </Typography>
            <div>Drink section here</div>
          </div>
        ) : (
          <div></div>
        )}

        <PopupboxContainer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orderCount: state.data.count,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(check);
